(function ($) {
    var self = {
        newPromotionCodeHtml: "",
        selectors: {
            addOrderPromotionCode: "[data-action='add-promotion-code']",
            removeOrderPromotionCode: "[data-action='remove-promotion-code']",
            promotionCodesContainer: "#promotion-codes-container"
        },
        initAddOrderPromotionCode: function () {
            $(document).on("click", self.selectors.addOrderPromotionCode, function () {
                var $this = $(this);
                var promotionCodesContainer = $(self.selectors.promotionCodesContainer);
                promotionCodesContainer.append($this.data("html"));

                var lastInput = promotionCodesContainer.find("input:last");
                if(lastInput.length > 0) {
                    lastInput.focus();
                }
            });
        },
        initRemoveOrderPromotionCode: function () {
            $(document).on("click", self.selectors.removeOrderPromotionCode, function () {
                var $this = $(this);
                $this.parent().remove();

                if($.isFunction(update_cart_block)) {
                    update_cart_block();
                }
            });
        },
        init: function () {
            self.initAddOrderPromotionCode();
            self.initRemoveOrderPromotionCode();
        }
    };

    $(document).ready(function () {
        self.init();
    })
})(jQuery);